import Blue from "~/core";

new Blue({
	name: 'Tabs',
	selector: ".tabs",
	setup(tabs) {
		const triggers = [...tabs.querySelectorAll('.tabs__trigger')];
		const contents = [...tabs.querySelectorAll('.tabs__content')];
		const toggleEvents = 'click.prevent enter.prevent space.prevent';

		triggers[0].classList.add('is-active');
		contents.forEach((el) => {
			if (el.getAttribute('data-id') === triggers[0].getAttribute('data-id')) el.classList.add('is-active');
		})

		const revealContent = item => {
			let triggerId = item.getAttribute('data-id');
			let foundContent = null;

			triggers.forEach((el) => {
				el.classList.remove('is-active');
			})
			contents.forEach((el) => {
				el.classList.remove('is-active');
				let contentId = el.getAttribute('data-id');
				if (contentId === triggerId) {
					foundContent = el;
				}
			})

			item.classList.add('is-active');
			if (foundContent) {
				foundContent.classList.add('is-active');
			}
		}

		//init
		triggers.forEach((trigger) => {
			this.$addEvents(trigger, toggleEvents, () => revealContent(trigger));
		});
	}
});
